import React, { useState } from 'react';
import { RemoveThreadIcon } from '../removethreadIcon/RemoveThreadIcon';

type Props = {
  selectedRowsLength: number;
  totalDealsQty: number;
  currentDealsQty: number;
  currentPageNumber: number;
  currentListLength: number;
  loadPreviousPage: () => void;
  loadNextPage: () => void;
  openDeleteModal: () => void;
};

export const DealsTableFooter: React.FC<Props> = ({
  selectedRowsLength,
  totalDealsQty,
  currentDealsQty,
  currentPageNumber,
  currentListLength,
  loadPreviousPage,
  loadNextPage,
  openDeleteModal,
}: Props): JSX.Element => {
  const [hoverDelete, setIsHoverDelete] = useState(false);

  const toggleHoverDelete = () => {
    setIsHoverDelete(!hoverDelete);
  };

  const totalPages = totalDealsQty
    ? Math.ceil(totalDealsQty / currentDealsQty)
    : 0;

  const buttonPreviousDisableCheck =
    !currentListLength || currentPageNumber < 2;

  const buttonNextDisableCheck =
    !currentListLength || currentPageNumber >= totalPages;

  const attrs = {
    wrapper: { className: 'deals-table-footer' },
    removeIcon: {
      className: selectedRowsLength
        ? 'deals-table-footer-remove-thread-icon'
        : 'hidden deals-table-footer-remove-thread-icon',
      onClick: openDeleteModal,
      onMouseEnter: toggleHoverDelete,
      onMouseLeave: toggleHoverDelete,
    },
    text: { className: 'deals-table-footer-remove-thread-icon-text' },
    pagination: {
      wrapper: { className: 'deals-table-footer__pagination' },
      numbers: { className: 'deals-table-footer__pagination-text' },
      buttonPrevious: {
        className: 'deals-table-footer__pagination-button',
        onClick: loadPreviousPage,
        disabled: buttonPreviousDisableCheck,
      },
      buttonNext: {
        className: 'deals-table-footer__pagination-button',
        onClick: loadNextPage,
        disabled: buttonNextDisableCheck,
      },
    },
  };

  const paginationValue = currentListLength ? (
    <div {...attrs.pagination.numbers}>
      {currentDealsQty * currentPageNumber - (currentDealsQty - 1)} -{' '}
      {currentDealsQty * currentPageNumber -
        (currentDealsQty - currentListLength)}{' '}
      of {totalDealsQty}{' '}
    </div>
  ) : (
    <div {...attrs.pagination.numbers}>1 of 1</div>
  );

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.removeIcon}>
        <RemoveThreadIcon inFooter isHoveredFromFooter={hoverDelete} />
        <span {...attrs.text}>
          Remove selected{' '}
          {selectedRowsLength === 1 ? 'engagement' : 'engagements'} from the
          list
        </span>
      </div>
      <div {...attrs.pagination.wrapper}>
        <button {...attrs.pagination.buttonPrevious}>{'<'}</button>
        {paginationValue}
        <button {...attrs.pagination.buttonNext}>{'>'}</button>
      </div>
      <div />
    </div>
  );
};
